<template>
    <div class>
      <!-- header start -->
      <van-nav-bar v-if="sacrifice"
        :title="sacrifice.SacrificeName"
        left-arrow
        fixed
        :z-index="99"
        @click-left="onClickLeft"
        :border="false"
      />
      <div class="navBarSpace"></div>
      <!-- header end -->
  
      <div>
        <div v-if="sacrifice" class="cells-title">{{sacrifice.SacrificeName}}单次包含如下:共计{{sacrifice.AppSacrificePackageRelationList.length}}项</div>
  
        <van-cell-group v-if="sacrifice">
          <div class="gift-box">
            <div class="gift-li" v-for="item in sacrifice.AppSacrificePackageRelationList" :key="item.Id">
              <div class="hd">
                <van-image
                  width="100%"
                  height="100%"
                  fit="contain"
                  :src="item.CoverPhotoPath"
                />
              </div>
              <div class="bd">
                {{item.SacrificeName}}
                <span class="corange">{{item.Coin}}</span> 币
              </div>
            </div>
          </div>
        </van-cell-group>
  
        <van-cell-group>
          <div class="cells-box" v-if="discount">
            <!-- <div class="cell van-hairline--bottom" @click="selectTimeShow = true">
              <span class="label">套餐持续：</span>
              <div class="package-time">
                <span>{{selectTime}}</span>
                <van-icon name="arrow-down" size="12" />
              </div>
            </div> -->
            <!-- <div class="cell van-hairline--bottom">
                    <span class="label">祭拜时间：</span>每天 7:30<span class="unit" @click="jibaiTimeShow = true">点击修改时间</span>
            </div>-->
            <div class="cell van-hairline--bottom">
              <span class="label">套餐价格：</span>{{Math.round(sacrifice.Coin)}}
              <span class="unit">孝爱币</span>
            </div>
            <!-- <div  class="cell van-hairline--bottom">
              <span class="label">折后需付：</span>
              <span class="corange">{{Math.round(sacrifice.Coin * discount.Day * discount.PercentageDiscount)}}</span>
              <span class="unit">孝爱币</span>
              <span  class="tag">{{discount.Sketch}}</span>
            </div>
             -->
             <van-field
                  v-model="ancestryName"
                  name="祭拜先人姓名"
                  placeholder="请填入祭拜先人姓名"
                />
             <div class="btn-area">
              <van-button block class="mybtn" @click="buysacrifice">马上祭拜</van-button>
            </div>
          </div>
        </van-cell-group>
      </div>
  
      <!-- 选择套餐 popup start -->
      <van-popup v-if="discount" v-model="selectTimeShow" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          cancel-button-text
          confirm-button-text="确定"
          :visible-item-count="4"
          :default-index="packagedefaultindex"
          @confirm="selectTimeShow = false"
          @cancel="selectTimeShow = false"
          @change="onTimeChange"
        />
      </van-popup>
      <!-- 选择套餐 popup end -->
  
      <!-- 祭拜时间 popup start -->
      <!-- <van-popup v-model="jibaiTimeShow" position="bottom">
        <van-datetime-picker
          v-model="currenDate"
          type="time"
          :min-hour="10"
          :max-hour="20"
          @confirm="jibaiTimeShow = false"
          @cancel="jibaiTimeShow = false"
          @change="jibaiTimeChange"
        />
      </van-popup>-->
      <!-- 祭拜时间 popup end -->
    </div>
  </template>
  
  <script>
  import { Toast, Dialog } from "vant";
  export default {
    data() {
      return {
        selectTime: "1月(9.5折)",
        selectTimeShow: false,
        currenDate: new Date(),
        jibaiTimeShow: false,
        placeType: 0,
        id: 0,
        muid:"",
        viewModel: null,
        discountList: null,
        sacrifice: null,
        columns: [],
        packagedefaultindex: 0,
        sketch : "",
        discount : null,
        ancestryName:""
      };
    },
    components: {},
    mounted() {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#f2f2f2");
    },
    beforeDestroy() {
      document.querySelector("body").removeAttribute("style");
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1);
      },
      onTimeChange(picker, value, index) {
        this.selectTime = value.text;
        this.discount = value.discount;
        //console.log(`当前值：${value}, 当前索引：${index}`);
      },
      jibaiTimeChange(picker, value, index) {
        //this.selectTime = value
        console.log(`当前值：${value}, 当前索引：${index}`);
      },
      init() {
        var that = this;
        that.$store
          .dispatch({
            type: "GetSacrificeSacrificePackageDetail",
            Id: that.id,
            mid:""
          })
          .then(
            res => {
              console.log(res);
              that.viewModel = res;
              that.discountList = res.DiscountList;
              that.sacrifice = res.Sacrifice;
              that.discountList.map((e, index) => {
                if (e.IsDefault) {
                  that.packagedefaultindex = index;
                  that.discount = e;
                }
                that.columns.push({
                  id: e.Id,
                  text: e.DiscountName,
                  discount: e,
                });
              });
            },
            err => {}
          );
      },
      buysacrifice() {
        var that = this;
        if(that.ancestryName=="")
        {
          Toast("请填入祭拜先人姓名，再进行操作！");
          return false;
        }
        Dialog.confirm({
          message:
            "您确定花费" +
            Math.round(that.sacrifice.Coin) + '孝爱币' +
            "，购买" +
            that.sacrifice.SacrificeName +
            "吗？"
        })
          .then(() => {
            that.$store
              .dispatch({
                type: "AddSacrificeSacrificeBuyVue",
                Id: that.sacrifice.SerialNumber,
                MemorialHallID: that.muid,
                PlaceType:3,
                DiscountId: 1,
                AncestryName:this.ancestryName
              })
              .then(
                res => {
                //console.log(res);
                  if (res.IsSuccess) {
                    that.$store.commit("setSacrificeList",res.Other);
                    that.$router.go(-2);
                  }
                },
                err => {}
              );
          })
          .catch(() => {});
      }
    },
    created() {
      //
      this.id = this.$route.query.id;
      this.placeType = this.$store.state.placeType;
      this.muid = this.$store.state.muid;
      this.init();
    }
  };
  </script>
  
  <style scoped>
  .cells-box .cell {
    height: 55px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    width: 100%;
  }
  .cells-box .cell .label {
    font-size: 14px;
    color: #999;
  }
  .cells-box .cell .unit {
    font-size: 14px;
    color: #999;
    margin-left: 10px;
  }
  .package-time {
    padding: 4px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
  }
  .package-time span {
    width: 110px;
    text-align: center;
  }
  .cells-box .cell .tag {
    background: url("~@/assets/images/worship/package_details_zhe_bg.png") center
      no-repeat;
    background-size: 100% 100%;
    width: 130px;
    height: 30px;
    text-align: center;
    font-size: 13px;
    line-height: 30px;
    color: orange;
    margin-left: 15px;
  }
  .cells-title {
    margin: 15px 15px 6px;
    font-size: 13px;
    color: #888;
  }
  .gift-box {
    padding: 10px 10px;
    overflow: hidden;
  }
  .gift-li {
    width: 50%;
    float: left;
    display: flex;
    align-items: flex-start;
    padding: 5px;
  }
  .gift-li > .hd {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    border: 1px solid rgba(255, 165, 0, 0.1);
    padding: 3px;
    background-color: rgba(255, 165, 0, 0.05);
  }
  .gift-li > .bd {
    flex: 1;
    overflow: hidden;
    font-size: 13px;
    color: #333;
  }
  .btn-area {
    padding: 24px 15px 20px;
  }
  </style>
  